import { Component, OnDestroy, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Customer } from '../../models/customer.model';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { CustomersService } from '../../services/customers.service';
import { Utilities } from '../../services/utilities';

@Component({
    selector: 'customers',
    template: require('./customers.component.html'),
    styles: [require('./customers.component.css')],
    animations: [fadeInOut]
})
export class CustomersComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];
    unFilteredCustomers: Customer[] = [];
    customers: Customer[] = [];
    customerTypes: string[] = ['Beide', 'Bedrijf', 'Particulier'];
    selectedCustomerType = 'Beide';
    loading: boolean;

    constructor(private accountService: AccountService, private customersService: CustomersService, private alertService: AlertService, private ngxLogger: NGXLogger) { }

    ngOnInit() {
        this.getCustomers();
    }

    private getCustomers() {
        this.loading = true;
        const getCustSubscriber = this.customersService.get()
            .subscribe((res: Customer[]) => {
                this.unFilteredCustomers = [...res];
                this.customers = [...res];
                this.loading = false;
            }, error => {
                this.loading = false;
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(getCustSubscriber);
    }

    OnCustomerTypeChange($event) {
        this.loading = true;
        if (this.unFilteredCustomers && this.unFilteredCustomers.length > 0) {
            switch (this.selectedCustomerType) {
                case 'Beide':
                    this.customers = [...this.unFilteredCustomers];
                    break;

                case 'Bedrijf':
                    this.customers = [...this.unFilteredCustomers.filter(f => f.CustomerRegistrationType === 'B')];
                    break;

                case 'Particulier':
                    this.customers = [...this.unFilteredCustomers.filter(f => f.CustomerRegistrationType === 'P')];
                    break;

                default:
                    break;
            }
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        }
    }

    exportExcel() {
        if (this.customers.length > 0) {
            let ids: string = "0";
            ids = this.customers.map(z => z.Id).toString();
            this.alertService.showMessage('Klanten', 'Bestandsdownload is bezig!', MessageSeverity.info);
            const exportExcelSubscribe = this.customersService.exportExcel(ids).subscribe(data => {
                saveAs(data, 'Klanten.xlsx');
                this.alertService.showMessage('Klanten', 'Bestandsdownload voltooid!', MessageSeverity.info);
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(exportExcelSubscribe);
        } else {
            this.alertService.showMessage('Klanten', 'Geen klanten gevonden!', MessageSeverity.warn);
        }
    }

    deleteCustomer(customer: Customer) {
        this.alertService.showDialog('Weet je zeker dat je ' + customer.Name + ' wilt verwijderen ?', DialogType.confirm, () => {
            const deleteCustSubscriber = this.customersService.delete(customer.Id).subscribe(res => {
                this.alertService.showMessage('Klant', 'Met succes verwijderd!', MessageSeverity.success);
                this.getCustomers();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteCustSubscriber);
        });
    }

    addUser(customer: Customer) {
        this.loading = true;
        const addUserSubscriber = this.accountService.addUser(customer).subscribe(res => {
            this.alertService.showMessage('Klant', 'Gebruiker succesvol toegevoegd!', MessageSeverity.success);
            this.getCustomers();
        }, error => {
            this.loading = false;
            const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
            if (errorMessage == 'Email Exists') {
                this.alertService.showMessage(customer.Email, 'Email bestaat al!', MessageSeverity.error);
            } else if (errorMessage == 'BTW Exists') {
                this.alertService.showMessage(customer.BTW, 'BTW bestaat al!', MessageSeverity.error);
            } else {
                this.alertService.showStickyMessage('Fout', 'Er is iets fout gegaan', MessageSeverity.error);
            }
        });
        this.subscribers.push(addUserSubscriber);
    }

    ngOnDestroy(): void {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get canviewCustomers() {
        return this.accountService.userHasPermission(Permission.viewCustomersPermission);
    }

    get canmanageCustomers() {
        return this.accountService.userHasPermission(Permission.manageCustomersPermission);
    }

    get canaddCustomers() {
        return this.accountService.userHasPermission(Permission.addCustomersPermission);
    }

    get caneditCustomers() {
        return this.accountService.userHasPermission(Permission.editCustomersPermission);
    }

    get candeleteCustomers() {
        return this.accountService.userHasPermission(Permission.deleteCustomersPermission);
    }

    get canlistCustomers() {
        return this.accountService.userHasPermission(Permission.listCustomersPermission);
    }

    get canapproveUsersPermission() {
        return this.accountService.userHasPermission(Permission.approveUsersPermission);
    }

    get canExportUsers() {
        return this.accountService.userHasPermission(Permission.exportCustomersPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/customers/customers.component.ts